define("ember-changeset/helpers/changeset", ["exports", "@ember/component/helper", "ember-changeset", "validated-changeset"], function (_exports, _helper, _emberChangeset, _validatedChangeset) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.changeset = changeset;
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"ember-changeset",0,"validated-changeset"eaimeta@70e063a35619d71f
  function changeset(_ref) {
    let [obj, validations] = _ref;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!obj) {
      // route transitions may trigger this
      return;
    }
    if ((0, _validatedChangeset.isChangeset)(obj)) {
      return obj;
    }
    if ((0, _validatedChangeset.isObject)(validations)) {
      if ((0, _validatedChangeset.isPromise)(obj)) {
        return obj.then(resolved => (0, _emberChangeset.Changeset)(resolved, (0, _validatedChangeset.lookupValidator)(validations), validations, options));
      }
      return (0, _emberChangeset.Changeset)(obj, (0, _validatedChangeset.lookupValidator)(validations), validations, options);
    }
    if ((0, _validatedChangeset.isPromise)(obj)) {
      return Promise.resolve(obj).then(resolved => (0, _emberChangeset.Changeset)(resolved, validations, {}, options));
    }
    return (0, _emberChangeset.Changeset)(obj, validations, {}, options);
  }
  var _default = _exports.default = (0, _helper.helper)(changeset);
});